var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"el-title"},[_c('CustomInput',{attrs:{"label":_vm.L.elTitleLabel || 'Heading',"value":_vm.element.labels[_vm.lang]},on:{"input":function($event){return _vm.updateLabel($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }